import React, { Component } from "react";
import PropTypes from "prop-types";
import * as ReactSpark from "react-spark";
const { Spinner, Stack, Box } = ReactSpark;

class Loading extends Component {
  render() {
    const { isLoading, message } = this.props;
    if (!isLoading) {
      return null;
    }
    return (
      <Stack id="loadingContainer" centerColumn>
        <Stack.Item>
          <Box padding="huge">
            <Spinner />
            <br />
            <span>{message}</span>
          </Box>
        </Stack.Item>
      </Stack>
    );
  }
}

Loading.propTypes = {
  isLoading: PropTypes.bool.isRequired
};

export default Loading;
